import styled from 'styled-components';

export const StyledAccountConfigurationInfoModalList = styled.ul`
   padding: 0;
   margin: 0;
   list-style: none;
   width: 100%;
`;
StyledAccountConfigurationInfoModalList.displayName = 'StyledAccountConfigurationInfoModalList';
